export const WHATS_NEW_STORAGE_KEY = "imagio-whats-new-last-seen";

export const FALLBACK_ROUTE = "/";

/** DOM id on the "Upload & Match" discovery tab, targeted by its What's New CTA. */
export const UPLOAD_MATCH_TAB_DOM_ID = "discovery-upload-match-tab";

/**
 * How a What's New CTA `feature` tag is resolved into an in-app action: navigate
 * to `route`, then—if `clickElementId` is set—click that element once it mounts.
 * The click hook lets a CTA open a feature that lives behind a tab/panel rather
 * than its own route (e.g. Upload & Match on the landing page).
 */
export interface FeatureExploreTarget {
  route: string;
  clickElementId?: string;
}

/**
 * The single place that maps a `#feature-tag` carried by a What's New CTA to the
 * action that opens it. Add or remove a feature key here — nothing else needs to
 * change. Unknown tags fall back to {@link FALLBACK_ROUTE} so a release authored
 * against a not-yet-shipped feature never dead-ends the user.
 */
export const FEATURE_EXPLORE_TARGETS: Record<string, FeatureExploreTarget> = {
  "upload-and-match": { route: "/", clickElementId: UPLOAD_MATCH_TAB_DOM_ID },
  search: { route: "/search" },
  "circular-cmf-guide": { route: "/circular-cmf-guide" },
  "help-center": { route: "/help-center" },
  profile: { route: "/profile" },
  settings: { route: "/settings" },
};

export function resolveFeatureExplore(tag: string): FeatureExploreTarget {
  return FEATURE_EXPLORE_TARGETS[tag] ?? { route: FALLBACK_ROUTE };
}
